module.exports = __webpack_public_path__ + "img/costal-5-2.0b42d1d8.jpg";